import React from "react";
import {TaModalContent, TaModalFooter, TaModalHeader} from "components/taUi/taModal/taModal";
import {TaButton} from "components/taUi/taButton/taButton";
import {Alert, Button, Form, Modal} from "react-bootstrap";
import {change, Field, formValueSelector, reduxForm, reset} from "redux-form";
import {connect} from "react-redux";
import {
  isWordListDetailImportModalLoading
} from "selectors/loading";
import {bindActionCreators} from "redux";
import {
  WORDLIST_DETAIL_IMPORT_FORM,
  WORDLIST_DETAIL_IMPORT_MODAL
} from "misc/constants";
import Spinner from "components/core/Spinner";
import {connectModal} from "redux-modal";
import SingleDropzoneField from "components/core/SingleDropzoneField";
import {XLSX_TYPE} from "misc/config";
import * as validators from "misc/validators";
import FontAwesome from "react-fontawesome";

class WordListImportModal extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.file && this.props.file !== prevProps.file) {
      const { file } = this.props;
      this.props.change('name', file.name)
    }
  }

  hide = () => {
    this.props.handleHide();
    this.props.reset(WORDLIST_DETAIL_IMPORT_FORM);
  };

  handleCancel = () => {
    this.props.change('file', null);
  }

  renderFiles = () => {
    return this.props.file && (
      <li>
        <a>
          {this.props.file.name}
          <span className="pull-right" style={{ marginTop: '-2px' }}>
            <Button bsStyle="danger" onClick={this.handleCancel} bsSize="xs">
              <FontAwesome name="ban" className="mr-5" />Remove
            </Button>
          </span>
        </a>
      </li>
    )
  }

  render() {
    const {
      show,
      error,
      handleSubmit,
      onSubmit,
      isLoading
    } = this.props;

    return (
      <Modal
        show={show}
        onHide={this.hide}
        animation={true}
        backdrop="static">
        <Form
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit((values => onSubmit(values)))}
          onReset={this.hide}
        >
          <TaModalHeader
            label={'Import Terms'}
            onCancel={this.hide}
          />
          <TaModalContent>
            <Field
              name="file"
              label="Microsoft Excel File (.xlsx)"
              validate={[
                validators.required
              ]}
              isRequired={true}
              accept={XLSX_TYPE}
              component={SingleDropzoneField}
            />
            <ul className="nav nav-pills nav-stacked">
              {this.renderFiles()}
            </ul>
            { error &&
              <div className="m-5">
                <Alert
                  bsStyle="danger"
                  className="mb-0">
                  <ul className="pl-15">
                    <li>{error}</li>
                  </ul>
                </Alert>
              </div>
            }
            <Spinner isLoading={isLoading} />
          </TaModalContent>
          <TaModalFooter>
            <TaButton
              type="reset"
              icon={'clear'}
              label={'Cancel'}
            />
            <TaButton
              type="submit"
              icon={'check'}
              label={'Import'}
              iconAlign={'right'}
              disabled={!this.props.file}
            />
          </TaModalFooter>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const formSelector = formValueSelector(WORDLIST_DETAIL_IMPORT_FORM);
  const file = formSelector(state, 'file');
  return {
    file: file,
    isLoading: isWordListDetailImportModalLoading(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    change,
    reset
  }, dispatch);
};

WordListImportModal = connectModal({
  name: WORDLIST_DETAIL_IMPORT_MODAL
})(WordListImportModal);

WordListImportModal = reduxForm({
  form: WORDLIST_DETAIL_IMPORT_FORM,
  enableReinitialize: true
})(WordListImportModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WordListImportModal);